import { EstheticianOnboardingLayoutVersionStepDbObject } from '@pomp-libs/core';
import { BULK_UPDATE_ONBOARDING_VERSION_STEPS } from './actions/action-types';

const OnboardingInitialState: {
  steps: EstheticianOnboardingLayoutVersionStepDbObject[];
  loading: boolean;
} = {
  steps: [],
  loading: false,
};

export const EstheticianOnboardingReducer = (
  state = OnboardingInitialState,
  { type, payload, status }
) => {
  switch (type) {
    case BULK_UPDATE_ONBOARDING_VERSION_STEPS:
      // Request is being made
      if (status === 'request')
        return {
          ...state,
          loading: true,
        };

      // Something went wrong
      if (status === 'fail')
        return {
          ...state,
          loading: false,
        };

      // Request was successful, update the state with the new data
      if (status === 'success')
        return {
          ...state,
          steps: payload,
          loading: false,
        };

    default:
      return state;
  }
};
